import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		seeMore: {
			fontStyle: 'italic',
			fontWeight: 'bold',
		},
	})
